import React, { useContext, useState } from "react";
import { motion } from "framer-motion";
// import logo from "../assets/images/bgremovelogo.png";
import logo from "../assets/images/genevieveLogo.png"
import JeevesInActionVideo from "../assets/videos/newvideo.mp4";
import introJeevesVideo from "../assets/videos/askgeneieve.mp4";
import { TbSend } from "react-icons/tb";
import { ContactUsModal } from "./ContactUsModal";
import { PatentContext } from "../context/PatentContextProvider";
import { IoNewspaperOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import BBBlogo from "../assets/images/footerlogo (1).png";
import { IoMdArrowDropright } from "react-icons/io";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { FaPlay } from "react-icons/fa6";

const LaunchingSoon = () => {
  const navigate = useNavigate();
  const [openVideo, setOpenVideo] = useState(false);
  const [video, setVideo] = useState();
  const { setPatentLicensingModal } = useContext(PatentContext);
  // const [patentLicensingModal, setPatentLicensingModal] = useState(false);
  const handleContactUsModal = () => {
    setPatentLicensingModal(true);
  };

  const handleOpenVideo = (title) => {
    setOpenVideo(true);
    if (title === "watchVideo") {
      setVideo(introJeevesVideo);
    } else {
      setVideo(JeevesInActionVideo);
    }
  };

  // const handleCloseModal = () => {
  //   setPatentLicensingModal(false);
  // };
  return (
    <div>
      <>
        <section className="relative w-full min-h-screen backdrop-blur-md bg-gradient-to-t from-[#707ba6] via-[#dde8f3] to-[#76abc5] overflow-y-auto">
          <div className="flex justify-end items-start m-3">
            <div className="flex items-center gap-3">
              <button
                type="button"
                className="
        group relative inline-flex items-center gap-2.5
        rounded-xl border border-black/10
        bg-[#314174] px-4 py-3
        text-sm font-semibold text-white
        backdrop-blur-md z-50
        shadow-[0_6px_20px_rgba(0,0,0,0.12)]
        transition-all duration-300
        hover:-translate-y-0.5 
        hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
        focus:outline-none cursor-pointer
      "
                onClick={handleContactUsModal}
              >
                <TbSend size={18} />
                <span className="tracking-wide">Drop us a line</span>
              </button>

              <img
                src={BBBlogo}
                alt="logo"
                className="h-10 w-auto object-contain z-50"
              />
            </div>
          </div>
          {/* 🔥 Vertical lines overlay */}
          <div className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.09),rgba(255,255,255,0.09)_3px,transparent_4px,transparent_100px)]" />

          <div className="z-10 text-center px-6  mt-10 md:mt-28 xl:mt-14 2xl:mt-28">
            {/* Logo */}
            <img
              src={logo}
              alt="Ask Geneieve"
              className="mx-auto mb-4 w-64 md:w-80"
              loading="lazy"
            />

            {/* Heading */}
            <h2
              className="text-4xl md:my-10 md:text-6xl lg:text-7xl font-extrabold tracking-tight
            bg-gradient-to-r from-[#1281b6] to-[#1281b6] bg-clip-text text-transparent pb-3"
            >
              Launching <span className="text-[#314174]">Soon</span>
            </h2>

            {/* Actions */}
            <div
              className="relative mt-14 md:mt-28 xl:mt-10 2xl:mt-28 mb-16 w-full
grid grid-cols-2 md:grid-cols-2
lg:flex lg:justify-center lg:items-center lg:flex-nowrap
gap-4 md:gap-6
px-4 md:px-10 lg:px-20 xl:px-28"
            >
              {/* Watch Video */}
              <div className="w-full md:w-auto">
                <button
                  type="button"
                  onClick={() => handleOpenVideo("watchVideo")}
                  className="group relative flex items-center justify-center gap-2
    rounded-xl bg-[#314174] px-2 py-3.5 lg:px-20 xl:px-10 2xl:px-10
    w-full transition-all duration-300 hover:-translate-y-0.5
    shadow-md hover:shadow-lg text-sm font-semibold text-white whitespace-nowrap"
                >
                  <FaPlay />
                  <span className="relative text-xs sm:text-sm ">The Genevieve Journey</span>
                </button>
              </div>

              {/* Genevieve */}
              <div className="w-full md:w-auto">
                <button
                  type="button"
                  onClick={() => handleOpenVideo("jeevesinaction")}
                  className="group relative flex items-center justify-center gap-2
    rounded-xl bg-[#314174] px-4 py-3.5 lg:px-20 xl:px-10 2xl:px-10
    w-full transition-all duration-300 hover:-translate-y-0.5
    shadow-md hover:shadow-lg text-sm font-semibold text-white whitespace-nowrap"
                >
                  <FaPlay />
                  <span className="relative text-xs sm:text-sm">Genevieve in Action</span>
                </button>
              </div>

              <div className="w-full md:w-auto col-span-2 md:col-span-1">
                {/* O'Hanlon */}
                <button
                  type="button"
                  onClick={() => navigate("/seven-pillars")}
                  className="flex items-center justify-center gap-2
    rounded-xl bg-[#314174] px-4 py-3.5 md:px-20 2xl:px-10
    w-full transition-all duration-300 hover:-translate-y-0.5 xl:px-10
    shadow-md hover:shadow-lg text-sm font-semibold text-white whitespace-nowrap"
                >
                  <IoNewspaperOutline size={18} />
                  <span className="text-xs sm:text-sm">O'Hanlon Center of Excellence</span>
                </button>
              </div>



              <div className="w-full md:w-auto col-span-2 md:col-span-1">
                {/* Press Release Dropdown */}
                <Menu as="div" className="relative w-full">
                  <MenuButton
                    className="flex items-center justify-center gap-2
      rounded-xl bg-[#314174] px-4 py-3.5 lg:px-20 xl:px-10 2xl:px-20
      w-full transition-all duration-300 hover:-translate-y-0.5
      shadow-md hover:shadow-lg text-sm font-semibold text-white whitespace-nowrap"
                  >
                    Press Release
                    <ChevronDownIcon className="size-5 text-gray-300" />
                  </MenuButton>

                  <MenuItems
                    className="absolute right-0 mt-2 w-full sm:w-72 bg-[#314174]
      rounded-md shadow-lg z-20"
                  >
                    <div className="py-2">
                      <MenuItem>
                        <a
                          href="https://investorshangout.com/kenneth-ohanlon-pioneering-the-future-of-digital-innovation-509688-/"
                          target="_blank"
                          className="block px-3 py-2 text-sm text-white hover:bg-white/10"
                        >
                          Pioneering the Future of Digital Innovation
                        </a>
                      </MenuItem>

                      <MenuItem>
                        <a
                          href="https://sg.finance.yahoo.com/news/inner-circle-acknowledges-kenneth-ohanlon-172800269.html"
                          target="_blank"
                          className="block px-3 py-2 text-sm text-white hover:bg-white/10"
                        >
                          Inner Circle acknowledges Kenneth O'Hanlon
                        </a>
                      </MenuItem>

                      <MenuItem>
                        <a
                          href="https://feature.marquiswhoswho.com/MWW_WSJ_Western_February12_2026"
                          target="_blank"
                          className="block px-3 py-2 text-sm text-white hover:bg-white/10"
                        >
                          Marquis Who's Who
                        </a>
                      </MenuItem>
                    </div>
                  </MenuItems>
                </Menu>
              </div>
            </div>
          </div>
          {/* <div className="absolute w-full font-semibold  bottom-0 bg-white/15">
            <div className="flex justify-center  items-center">
              <span className="py-2">© 2026 Ask Genevieve. All Rights Reserved</span>
            </div>
          </div> */}
          <div className="fixed w-full font-semibold  bottom-0 bg-white/15">
            <div className="flex justify-center  items-center">
              <span>© 2026 Genevieve. All Rights Reserved</span>
            </div>
          </div>
        </section>

        {/* Video Modal */}
        {openVideo && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={() => setOpenVideo(false)}
          >
            <div
              className="relative mx-4 w-full max-w-6xl rounded-2xl border border-[#121315]/40 bg-[#121315]/30 backdrop-blur-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close */}
              <button
                onClick={() => setOpenVideo(false)}
                aria-label="Close video"
                className="absolute -right-4 -top-4 flex h-9 w-9 items-center justify-center rounded-full bg-[#1281b6] text-white font-bold shadow-lg transition hover:scale-105 cursor-pointer"
              >
                ✕
              </button>

              {/* Video */}
              <video
                src={video}
                controls
                autoPlay
                className="w-full rounded-2xl"
              />
            </div>
          </div>
        )}
      </>
      <ContactUsModal />
    </div>
  );
};

export default LaunchingSoon;
